/** In-product onboarding walkthrough (same clip as marketing Trial / docs). */

export const ONBOARDING_VIDEO = {
  youtubeVideoId: "8LvePrA89nQ",
  title: "User onboarding — Customer Payments Hub",
  heading: "Welcome to DecisionPen",
  description:
    "Watch a short walkthrough: from knowledge to a living map you can research and decide from.",
};

const DISMISS_KEY = "dp_onboarding_video_dismissed";

export function readOnboardingVideoDismissed() {
  try {
    return localStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeOnboardingVideoDismissed(dismissed) {
  try {
    if (dismissed) localStorage.setItem(DISMISS_KEY, "1");
    else localStorage.removeItem(DISMISS_KEY);
  } catch {
    /* ignore */
  }
}

export function onboardingVideoEmbedUrl({ autoplay = false } = {}) {
  const id = ONBOARDING_VIDEO.youtubeVideoId;
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
  });
  if (autoplay) params.set("autoplay", "1");
  return `https://www.youtube.com/embed/${id}?${params.toString()}`;
}
